import { addEvent } from './util/event';

import { uuid } from './util/uuid';

import { loadMsg } from './loadMsg';

/**
 * Attach hashChange event function
 * Example: `hashChange(this.instantUploader, this._state, opts)`
 * @param {Function} function to upload log data
 * @param {Object} object to logger state
 * @param {Object} logger options
 * reset logger pvid, ajaxid and logorder state, and send loadMsg log when hashChange event emit
 */
export function hashChange (uploader, state, opts) {
  addEvent(window, 'hashchange', function () {
    if (opts.hashchange && opts.hashchange.pvid && (opts.hashchange.pvid === 'hash')) {
      if (typeof state === 'object' && state !== null) {
        state.pvid = uuid() || '';
        state.ajaxid = 0;
        state.logorder = 1;
      }
      loadMsg(uploader, opts);
    }
  });
}

export function hackPushState(uploader, state, opts) {
  (function (history) {
    var pushState = history.pushState;
    history.pushState = function (state) {
      if (typeof history.onpushstate === 'function') {
        history.onpushstate({ state: state });
      }

      if (opts.hashchange && opts.hashchange.pvid && (opts.hashchange.pvid === 'hash')) {
        // FIXED:
        // 用于兼容用户在使用pushState时，传递的state值为null或者非对象类型的情况时报错的问题
        // 比如：history.pushState(null, null, '/new-url');
        // TODO: 处理state参数，使用其他参数来生成pvid，防止污染用户state
        if (typeof state === 'object' && state !== null) {
          state.pvid = uuid() || '';
          state.ajaxid = 0;
          state.logorder = 1;
        }
        loadMsg(uploader, opts);
      }

      return pushState.apply(history, arguments);
    };
  })(window.history);
}
